import { render, staticRenderFns } from "./Transacoes.vue?vue&type=template&id=a55299a0&"
import script from "./Transacoes.vue?vue&type=script&lang=js&"
export * from "./Transacoes.vue?vue&type=script&lang=js&"
import style0 from "./Transacoes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports